<template>
  <div class="jl-auc-record">
    <table class="table">
      <thead>
        <tr>
          <th>状态</th>
          <th>竞拍人</th>
          <th>出价金额</th>
          <th>出价时间</th>
          <th>出价类型</th>
        </tr>
      </thead>
    </table>
    <div v-loading="isloading" class="jl-loading-box">
      <div class="jl-com-nodata-tips" v-if="recordList.length ==  0">
        <div class="jl-com-nodata-box">
          <i class="jl-icon-wushuju"></i>
          <p class="text">暂无数据</p>
        </div>
      </div>
      <table class="table">
        <tbody>
          <tr v-for="(item, index) in recordList" :key="item.id">
            <td>
              <p :class="[index === 0?'text active':'text']">{{index === 0?'领先':'出局'}}</p>
            </td>
            <td>
              <p :class="[index === 0?'text active':'text']">{{item.frontUser.userName}}</p>
            </td>
            <td>
              <p :class="[index === 0?'text active':'text']">￥ {{item.bidPrice}}</p>
            </td>
            <td>
              <p :class="[index === 0?'text active':'text']">{{item.bidDate}}</p>
            </td>
            <td>
              <p :class="[index=== 0?'text active':'text']">{{item.bidType === 0?'秒杀':'普通出价'}}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    recordList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  watch: {
    recordList(n, o) {
      this.setTips();
    }
  },
  data() {
    return {
      isloading: false,
      nodata: false
    };
  },
  created() {
    this.setTips;
  },
  methods: {
    setTips() {
      this.nodata = this.recordList.length > 0 ? false : true;
    }
  }
};
</script>

<style lang="scss" scoped>
.jl-auc-record {
  .table {
    width: 100%;
    max-width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
  }
  thead {
    background: #eff2f5;
    border-bottom: 1px solid #e0e0e0;
  }
  th,
  td {
    width: 20%;
    text-align: center;
    font-size: 14px;
    color: #333;
    font-weight: 500;
    padding: 15px 0;
    &:first-child {
      text-align: left;
      padding-left: 35px;
    }
  }
  tbody {
    tr:nth-child(2n) {
      background: #f8f8fb;
    }
  }
  tbody td {
    padding: 15px 0;
    text-align: center;
    &:first-child {
      text-align: left;
      padding-left: 23px;
      p.text {
        position: relative;
        padding-left: 15px;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          width: 8px;
          height: 8px;
          margin-top: -4px;
          border-radius: 4px;
          background: #666;
        }
        &.active::before {
          background: #e50011;
        }
      }
    }
    p.text {
      font-size: 14px;
      color: #666;
      &.active {
        color: #e50011;
      }
    }
  }
}
</style>
